module.exports = __webpack_public_path__ + "img/palmareal.ec6a5d8b.jpg";